












































import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableOptions,
    removeItemsFromView,
    getTableCaption,
} from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { DxDataGrid } from 'devextreme-vue/data-grid';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { ActivitySchedule } from '@/dto';
import { IContext } from '@/api/dto';
import ActivitySchedulesListTable from './ActivitySchedulesListTable.vue';
import DevExpress from 'devextreme/bundles/dx.all';

@Component({
    components: {
        DxDataGrid,
        ActivitySchedulesListTable,
        TableOptions,
    },
})
export default class ActivitySchedulesListPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'activitySchedules-control';

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof ActivitySchedule,
            load: this.load,
            insert: (activityShedule: ActivitySchedule) => this.insert(activityShedule),
            update: (id: string, data: ActivitySchedule) => this.update(id, data),
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public get selectedRow() {
        if (this.table && this.table!.getSelectedRowKeys().length === 1) {
            return this.table!.getSelectedRowKeys()[0];
        }
    }

    public addActivitySchedule() {
        this.tableInstance.addMode = true;
        this.table!.addRow();
    }

    public editActivitySchedule() {
        this.tableInstance.addMode = false;
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    private get tableInstance(): ActivitySchedulesListTable {
        return this.$refs['table-component'] as ActivitySchedulesListTable;
    }

    private deleteActivitySchedule() {
        this.tableInstance.deleteActivitySchedule();
    }

    private showDayInactivityIntervals() {
        this._windowsService!.open('day-inactivity-intervals-list-page', {
            activityScheduleAlias: this.selectedRow
        });
    }

    private async load() {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}/ActivitySchedules`;
        const data = await this._fetchService!.get<IContext>(url);
        return data.activitySchedules ? data.activitySchedules : [];
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async insert(activityShedule: ActivitySchedule) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        const data = {
            ActivitySchedules_Partial: [activityShedule],
        };
        return await this._fetchService!.post<ActivitySchedule>(
            url,
            JSON.stringify(data)
        );
    }

    private async update(id: string, activityShedule: ActivitySchedule) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        activityShedule.id = id;
        const data = {
            ActivitySchedules_Partial: [activityShedule],
        };
        return await this._fetchService!.post<ActivitySchedule>(
            url,
            JSON.stringify(data)
        );
    }
}
